import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsSmartSignalsPage } from 'features/visitorDetails'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/smart-signals'
)({
  component: VisitorDetailsSmartSignalsPage,
})
